// Generated by CoffeeScript 2.4.1
(function() {
  var Weaver, WeaverAttributeNode;

  Weaver = require('./Weaver');

  WeaverAttributeNode = class WeaverAttributeNode extends Weaver.Node {
    constructor(nodeId, graphId, upsert) {
      // suppress check because it is used for sparql results
      // throw new Error("Please always supply a attId when constructing WeaverAttributeNode") if not nodeId?
      super(nodeId, graphId, upsert);
    }

    static load(nodeId, params = {}) {
      var query;
      if (params.NodeClass == null) {
        params.NodeClass = WeaverAttributeNode;
      }
      query = new Weaver.Query();
      query.withAttributes();
      return query.get(nodeId, params);
    }

  };

  // Export
  module.exports = WeaverAttributeNode;

}).call(this);
